import produce from 'immer';

import {
	SET_PAYMENT_CONFIG,
	SET_PAYMENT_RESPONSE,
	SET_PAYMENT_ADDITIONAL_DETAILS,
	SET_PAYMENT_ERROR,
	RESET_PAYMENT,
	SET_REPEAT_PAYMENT_ERROR,
	CLEAR_ERRORS
} from '../actions/AdyenPaymantActions';

import { adyenConfig } from '../components/payments/adyen/Adyen/config';

const initialState = {
	config: { ...adyenConfig },
	paymentMethods: {},
	paymentResponse: null,
	paymentAdditionalDetailsResponse: null,
	error: null,
	isAdyenRepeatPayment: false,
	repeatPaymentError: null
};

export default class AdyenPaymentReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 * @return {{items: Array, loaded: boolean}}
	 */
	static reduce(state = initialState, action) {
		switch (action.type) {
			case SET_PAYMENT_CONFIG:
				return produce(state, draftState => {
					draftState.paymentMethods = action.payload.paymentMethods;
					draftState.config.clientKey = action.payload.clientKey;
					draftState.config.environment = action.payload.environment;
					draftState.component = action.payload.component;
					draftState.isAdyenRepeatPayment = !!action.payload.isAdyenRepeatPayment;
				});
			case SET_PAYMENT_RESPONSE:
				return produce(state, draftState => {
					draftState.paymentResponse = action.payload;
				});
			case SET_PAYMENT_ADDITIONAL_DETAILS:
				return produce(state, draftState => {
					draftState.paymentAdditionalDetailsResponse = action.payload;
				});
			case SET_PAYMENT_ERROR:
				return produce(state, draftState => {
					draftState.error = action.payload;
				});
			case RESET_PAYMENT:
				return produce(state, draftState => {
					draftState.config = { ...adyenConfig };
					draftState.paymentMethods = {};
					draftState.paymentResponse = null;
					draftState.paymentAdditionalDetailsResponse = null;
					draftState.error = null;
				});
			case SET_REPEAT_PAYMENT_ERROR:
				return produce(state, draftState => {
					draftState.repeatPaymentError = action.payload;
				});
			case CLEAR_ERRORS:
				return produce(state, draftState => {
					draftState.error = null;
					draftState.repeatPaymentError = null;
				});
			default:
				return state;
		}
	}
}



// WEBPACK FOOTER //
// ./reducers/AdyenPaymentReducer.js